<template>
    <div class="flex-column list">
        <video :src="path" controls class="video" width="100%" v-if='type==="music"'></video>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        title: String,
        type: String,
        config: Object,
        path: String
    },
    computed: {},
    methods: {
        handleClick() {}
    }
}
</script>
<style scoped>
</style>
